import { createSlice, current } from '@reduxjs/toolkit';

export const superheatSlice = createSlice({
  name: 'superheat',
  initialState: [],
  reducers: {
    setSuperheats: (state, action) =>
    {
      state = action.payload;

    }
  }
});

export const { setSuperheats } = superheatSlice.actions;

export const getSuperheats = state => state.superheat;



export default superheatSlice.reducer;
